// extracted by mini-css-extract-plugin
export default {"descriptionField":"ChangeStageDialog_descriptionField__ucobv","downloadFileButton":"ChangeStageDialog_downloadFileButton__FDIr6","stageFooter":"ChangeStageDialog_stageFooter__miVoT"};